import React, { Component } from "react";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
} from "firebase/firestore";

import {TreeNode} from "../reducers/address.reducer"
import { updateAddressAction } from "../actions/address.action";
import { db } from "./auth";
let deviceAddressInstance;
let rootAddressNode = null;

class DevideAddress {
  constructor() {
      if (deviceAddressInstance) {
          throw new Error("DevideAddres Instance already created");
      }
      deviceAddressInstance = this;
  }
  /** Expoeted functions*/
  getInstance() {
      return this;
  }

  deinit () {
    rootAddressNode = null;
  }

  async initService() {
    if (rootAddressNode === null || rootAddressNode.length <= 0) {
      await this.getAllAddressAPICall();
    }
  }
  
  getAddress(zoneId, wardId, placeId, streetId) {
    let zone, ward, place, street;

    let zoneNode = this.findNode(zoneId, rootAddressNode);
    if (zoneNode) {
      zone = zoneNode.value;
      let wardNode = this.findNode(wardId, zoneNode);
      if (wardNode) {
        ward = wardNode.value;
        let placeNode = this.findNode(placeId, wardNode);
        if (placeNode) {
          place = placeNode.value;
          let streetNode = this.findNode(streetId, placeNode);
          if (streetNode) {
            street = streetNode.value;
          }
        }
      }
    }

    return { zone, ward, place, street };
  }

  findNode(id, node) {
    for (var i = 0, length = node.descendants.length; i < length; i++) {
      if (node.descendants[i].id == id) {
        return node.descendants[i];
      }
    }
    return null;
  }

  async getAllPlaces() {
    const q = query(collection(db(), "area/dindigul/places"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // get places and streets from the result and load in tree
      let placeRecord = doc.data();
      const placeNode = new TreeNode(placeRecord.id, placeRecord.name);
      let zoneNode = this.findNode(placeRecord.zid, rootAddressNode);
      let wardNode = this.findNode(placeRecord.wid, zoneNode);
      wardNode.descendants.push(placeNode);
      placeRecord?.streets?.forEach((streetItem) => {
        const streetNode = new TreeNode(streetItem.id, streetItem.name);
        placeNode.descendants.push(streetNode);
      });
    });
  }

  // async getAllAddressAPICall() {
  //   let zoneList = [];
  //   const docRef = doc(db(), "area", "dindigul");
  //   const docSnap = await getDoc(docRef);
  //   rootAddressNode = new TreeNode("dindigul", "dindigul");
  //   if (docSnap.exists()) {
  //     const record = docSnap.data();
  //     zoneList = [...record.zones];
  //     zoneList.forEach(({ id = "", name = "", wards = [] }) => {
  //       const zoneNode = new TreeNode(id, name);
  //       rootAddressNode.descendants.push(zoneNode);
  //       wards.forEach((wardItem) => {
  //         const wardNode = new TreeNode(wardItem.id, wardItem.name);
  //         zoneNode.descendants.push(wardNode);
  //       });
  //     });
  //     await this.getAllPlaces(db);
  //     // dispatch(updateAddressAction(rootAddressNode));
  //   }
  // };
  

  async getAllAddressAPICall() {
    let zoneList = [];
    const docRef = doc(db(), "addr", "zones");
    const docSnap = await getDoc(docRef);
    rootAddressNode = new TreeNode("zone", "zone");
    if (docSnap.exists()) {
      const record = docSnap.data();
      zoneList = [...record.zn_list];
      zoneList.forEach(({ id = "", name = "", wards = [] }) => {
        const zoneNode = new TreeNode(name, name);
        rootAddressNode.descendants.push(zoneNode);
        wards.forEach((wardItem) => {
          const wardNode = new TreeNode(wardItem, wardItem);
          zoneNode.descendants.push(wardNode);
        });
      });
      // await this.getAllPlaces(db);
      // dispatch(updateAddressAction(rootAddressNode));
    }
  };

  getZones(all = true) {
    // const zoneList = rootAddressNode.descendants.map((item) => ({
    //   label: item.value,
    //   value: item.id,
    // })) || [];

    let zoneList = all?[{label: "All",value: 0}]:[];
    for (let item of rootAddressNode.descendants) {
      zoneList.push({
        label: item.value,
        value: item.id,
      });
    }
    return zoneList;
  }

  getWards(zoneId, all = true) {
    let wards = all?[{label: "All",value: 0}]:[];
    if (zoneId !== 0) {
      const zoneNode = this.findNode(zoneId, rootAddressNode);
      if (zoneNode) {
        // wards = zoneNode.descendants.map((item) => ({
        //   label: item.value,
        //   value: item.id,
        // })) || [];
        for (let item of zoneNode.descendants) {
          wards.push({
            label: item.value,
            value: item.id,
          });
        }
      }
    }
    return wards;
  }

}

const DeviceAddressService = Object.freeze(new DevideAddress());
export default DeviceAddressService;